export const CLIENTID = process.env.REACT_APP_CLIENTID;
export const SERVER = process.env.REACT_APP_SERVER;
export const MEDIA_SERVER = process.env.REACT_APP_MEDIA_SERVER;
export const MEDIA_STORAGE = process.env.REACT_APP_MEDIA_STORAGE;
export const MYBESTUSER = process.env.REACT_APP_MYBESTUSER;
export const MYBESTUSER_API = process.env.REACT_APP_MYBESTUSER_API;
export const ROLLBARACCESSTOKEN = process.env.REACT_APP_ROLLBARACCESSTOKEN;

// Mainland-China deployment detection. tesseract.js (OCR) pulls language
// packs from jsDelivr which is blocked in mainland China, so we hide OCR
// in that build. We test each env URL independently so a value like
// "https://mybestta.cn" (no trailing slash) is detected even when other
// env vars are also present in the concatenation.
export const IS_CN_REGION = [SERVER, MEDIA_STORAGE, MEDIA_SERVER].some(
  (v) => /\.cn(\/|$|:|\s)/i.test(v || "")
);

// TODO: check variable import null, or write a test
